



































import Vue, { PropType } from "vue"
import MaterialIcon from "~/components/guideline/icon/MaterialIcon.vue"
import { SkillTag } from "~/backendApis/viewModel"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    skillTag: {
      type: Object as PropType<SkillTag>,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    yearsOfExperienceName(): string | null {
      if (
        !this.skillTag.minYearsOfExperience &&
        this.skillTag.maxYearsOfExperience === 1
      ) {
        return "1年未満"
      }
      if (
        this.skillTag.minYearsOfExperience === 1 &&
        this.skillTag.maxYearsOfExperience === 2
      ) {
        return "1年"
      }
      if (
        this.skillTag.minYearsOfExperience === 2 &&
        this.skillTag.maxYearsOfExperience === 3
      ) {
        return "2年"
      }
      if (
        this.skillTag.minYearsOfExperience === 3 &&
        this.skillTag.maxYearsOfExperience === 5
      ) {
        return "3〜5年"
      }
      if (
        this.skillTag.minYearsOfExperience === 5 &&
        !this.skillTag.maxYearsOfExperience
      ) {
        return "5年以上"
      }
      return ""
    },
  },
  methods: {
    handleClickTagButton() {
      if (this.isDisabled) {
        return
      }

      this.$emit("click-tag-button")
    },
    handleClickClearIcon() {
      if (this.isDisabled) {
        return
      }

      this.$emit("click-clear-icon")
    },
  },
})
